<template>
	<section
		class="standard_header"
		:class='[type, header_type]'
		:style="{'--content-bg-pos': image_position, '--quick-links-height': quick_links_height - (window.width < 1280 ? 30 : 0) + 'px', '--quick-links-height-neg': '-' + 61 + 'px'}"
	>
		<div class="container">
			<div class="content">

				<div
					class="text"
					:class="[{'no-image': !parsedImage}, type, header_type]"
				>
					<slot name="breadcrumbs"></slot>

					<div class="inner">
						<h1
							v-if='title'
							:data-highlightword="getWordsInFirstRow(title)"
							v-html="title"
							:class='[type, header_type]'
						></h1>
						<div
							v-if='description'
							class="body"
							:class='[type, header_type]'
							v-html="description"
						></div>

						<div
							class='cta_container'
							v-if='parsedCta'
						>
							<secondary-button
								:label="parsedCta.title"
								:link="parsedCta"
								theme='reverse'
							></secondary-button>
						</div>

					</div>

				</div>

				<div
					class='image'
					:class="[{'no-image': !parsedImage}, type, header_type]"
					:style="{'--image-mask': 'url(' + imageMask + ')', '--image-mask-mobile': 'url(' + imageMaskMobile + ')', '--no-image-mask': 'url(' + imageNoImageMask + ')'}"
					v-if="header_type != 'slim'"
				>

					<img
						v-if="parsedImage"
						:src='parsedImage.url'
						:alt='title'
						:class='type'
					/>

				</div>

			</div>

		</div>

	</section>
</template>

<script>
import ImageMask from '../../images/standard-header-mask.svg';
import ImageNoImageMask from '../../images/standard-header-no-image-mask.svg';
import ImageMaskMobile from '../../images/standard-header-mobile-mask.svg';
import SecondaryButton from './SecondaryButton.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			imageMask: ImageMask,
			imageNoImageMask: ImageNoImageMask,
			imageMaskMobile: ImageMaskMobile,
		};
	},

	props: {
		title: {},
		description: {},
		image: {},
		image_position: {
			default: 'center',
		},
		project_details: {},
		type: {},
		header_type: {},
		call_to_action: {},
	},

	computed: {
		parsedImage() {
			if (this.image) {
				return JSON.parse(this.image);
			} else {
				return null;
			}
		},

		parsedProjectDetails() {
			if (this.project_details) {
				return JSON.parse(this.project_details);
			} else {
				return null;
			}
		},

		parsedCta() {
			if (this.call_to_action) {
				return JSON.parse(this.call_to_action);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			this.getQuickLinksHeight();
		},

		handleAccordionToggle(isOpen) {
			console.log('Accordion state:', isOpen);
			const element = this.$refs.quickLinks;

			// Check if the element exists
			if (element) {
				// Use getBoundingClientRect to get the height
				const height = element.getBoundingClientRect().height;

				// Alternatively, you can use offsetHeight
				// const height = element.offsetHeight;
				this.quick_links_height = height;
			} else {
				this.quick_links_height = 0;
			}

			console.log('Quicklinks Height:', this.quick_links_height);
		},

		getQuickLinksHeight() {
			// Access the element via its ref
			const element = this.$refs.quickLinks;

			// Check if the element exists
			if (element) {
				// Use getBoundingClientRect to get the height
				const height = element.getBoundingClientRect().height;

				// Alternatively, you can use offsetHeight
				// const height = element.offsetHeight;
				this.quick_links_height = height;
			} else {
				this.quick_links_height = 0;
			}
		},

		getWordsInFirstRow(paragraph) {
			const words = paragraph.trim().split(' ');

			const firstRowWords = [];
			const tempElement = document.createElement('span');
			document.body.appendChild(tempElement);

			for (const word of words) {
				tempElement.textContent = `${firstRowWords.join(' ')} ${word}`;

				if (tempElement.offsetTop !== firstRowWords.length) {
					break;
				}

				firstRowWords.push(word);
			}

			document.body.removeChild(tempElement);

			return firstRowWords;
		},
	},

	components: { SecondaryButton },

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.standard_header {
	background: var(--midnight);
	position: relative;
	margin-bottom: 0;
	overflow-x: clip;

	&.post {
		background: var(--white);
		padding-top: 50px;

		@media (max-width: $tablet) {
			padding-top: 32px;
		}

		.container:first-of-type {
			max-width: var(--max-width);
			margin: 0 auto;
			padding: 0 40px;
			display: grid;
			grid-template-columns: repeat(12, 1fr);
			column-gap: var(--gutter-tablet-desktop);
			height: max-content;

			@media (max-width: 1520px) {
				padding-left: 40px;
			}

			@media (max-width: $tablet) {
				grid-template-columns: repeat(4, 1fr);
				padding: 0 0;
			}
		}
	}

	&.slim {
		background: var(--white);

		@media (max-width: $tablet) {
			min-height: unset;
		}
	}

	svg {
		position: absolute;
		bottom: 0px;
		right: 0px;
		z-index: 5;

		@media (max-width: $tablet) {
			display: none;
		}
	}

	@media (max-width: $tablet) {
		min-height: 350px;
	}

	.container:first-of-type {
		min-height: 100%;
		position: relative;
		max-width: 100%;
		padding-left: calc((100% - 1440px) / 2);
		padding-right: 0;
		z-index: 1;

		@media (max-width: 1520px) {
			padding-left: 40px;
		}

		@media (max-width: $tablet) {
			grid-template-columns: repeat(4, 1fr);
			padding: 0 0;
		}
	}

	.content {
		grid-column: 1 / span 12;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		column-gap: 0;
		position: relative;
		z-index: 15;
		overflow: hidden;
		column-gap: var(--gutter-tablet-desktop);

		.template-resource &,
		.post-type-archive & {
			padding-bottom: 40px;

			@media (max-width: $tablet) {
				padding-bottom: 0;
			}
		}

		@media (max-width: $tablet) {
			grid-column: 1 / span 4;
			grid-template-columns: repeat(4, 1fr);
			max-height: unset;
			display: flex;
			flex-direction: column;
		}

		.text {
			grid-column: span 5;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			gap: 32px;
			position: relative;
			z-index: 5;
			padding-top: 60px;
			padding-bottom: 60px;
			padding-right: 40px;

			&.post {
				padding-top: 0;
				padding-bottom: 30px;
			}

			&.no-image {
				grid-column: span 7;
			}

			@media (min-width: $tablet) {
				padding-left: 0;
				padding-top: 48px;
				padding-bottom: 48px;
				padding-right: 0;
			}

			@media (max-width: $tablet) {
				grid-column: span 4;
				padding-left: 24px;
				padding-top: 24px;
				padding-bottom: 24px;
				padding-right: 24px;
			}

			/* @media (max-width: $tablet) and (orientation: portrait) {
				grid-column: span 4;
				height: 100%;
				padding-top: 24px;
				padding-bottom: 24px;
				padding-left: 24px;
				padding-right: 24px;
				justify-content: flex-start;
			} */

			#breadcrumbs {
				position: relative;

				&.post,
				&.slim {
					.breadcrumb_container {
						> span {
							display: flex;
							align-items: center;
							flex-wrap: wrap;

							@media only screen and (max-width: 768px) {
								&:first-child a {
									text-indent: -9999px;
									color: var(--midnight);

									&::before {
										content: '…';
										text-indent: 0;
									}
								}
							}

							span {
								color: var(--white);
								font: normal normal normal 14px/20px var(--primary-font-family);

								&.breadcrumb_last {
									color: var(--cobalt);
									font: normal normal normal 14px/20px
										var(--primary-font-family);
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
									width: 350px;
									display: inline-block;

									@media (max-width: $tablet) {
										width: unset;
									}

									*,
									>>> {
										color: var(--cobalt);
									}
								}

								a {
									font: normal normal normal 14px/20px
										var(--primary-font-family);
									color: var(--midnight);
									text-decoration: none;

									&:hover {
										text-decoration: underline;
									}
								}

								strong {
									font: normal normal bold 14px/20px var(--primary-font-family);
									color: var(--midnight);
								}

								&.divider {
									&::before {
										margin: 0 16px 0;
										font: normal normal 500 11px/20px var(--primary-font-family);
										content: '/';
										display: inline-block;
										color: var(--cobalt);
									}
								}

								&:last-child {
									a {
										font: normal normal bold 14px/20px
											var(--primary-font-family);
									}
								}
							}
						}
					}
				}

				.breadcrumb_container {
					> span {
						display: flex;
						align-items: center;
						flex-wrap: wrap;

						@media only screen and (max-width: 768px) {
							&:first-child a {
								text-indent: -9999px;
								color: var(--white);

								&.post {
									color: var(--midnight);
								}

								&::before {
									content: '…';
									text-indent: 0;
								}
							}
						}

						span {
							color: var(--white);
							font: normal normal normal 14px/20px var(--primary-font-family);

							&.breadcrumb_last {
								color: var(--cobalt);
								font: normal normal normal 14px/20px var(--primary-font-family);
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								width: 350px;
								display: inline-block;

								@media (max-width: $tablet) {
									width: unset;
								}

								*,
								>>> {
									color: var(--cobalt);
								}
							}

							a {
								font: normal normal normal 14px/20px var(--primary-font-family);
								color: var(--white);
								text-decoration: none;

								&:hover {
									text-decoration: underline;
								}

								&.post {
									color: var(--midnight);
								}
							}

							strong {
								font: normal normal bold 14px/20px var(--primary-font-family);
								color: var(--white);

								&.post {
									color: var(--midnight);
								}
							}

							&.divider {
								&::before {
									margin: 0 16px 0;
									font: normal normal 500 11px/20px var(--primary-font-family);
									content: '/';
									display: inline-block;
									color: var(--cobalt);
								}
							}

							&:last-child {
								a {
									font: normal normal bold 14px/20px var(--primary-font-family);
								}
							}
						}
					}
				}
			}

			> .inner {
				display: flex;
				flex-direction: column;
				gap: 32px;

				h1 {
					color: var(--cobalt);
					margin: 0;
					padding-right: 50px;
					padding-top: 0x;

					&::first-line {
						color: var(--cobalt);
					}

					@media (max-width: $tablet) {
						margin: 0 0 0;
						padding-top: 0;
						padding-right: 0;
					}
				}

				.body {
					color: var(--white);
					padding-right: 50px;
					margin: 0;

					&.post,
					&.slim {
						color: var(--midnight);
					}

					@media (max-width: $tablet) {
						padding-right: unset;
					}

					&::v-deep {
						p,
						em,
						p em {
							color: var(--white);
							padding-right: 0;
							margin: 0;
							font-style: normal;

							@media (max-width: $tablet) {
								padding-right: unset;
							}
						}
					}
				}
			}
		}

		.image {
			grid-column: 6 / span 7;
			display: flex;
			flex-direction: column;
			justify-content: center;
			/* position: relative; */
			min-height: 350px;
			max-height: 524px;
			position: relative;
			z-index: 4;
			-webkit-mask-image: var(--image-mask);
			mask-image: var(--image-mask);
			-webkit-mask-repeat: no-repeat;
			mask-repeat: no-repeat;
			mask-size: cover;
			mask-position: right center;
			background: var(--cobalt);

			&.post {
				-webkit-mask-image: unset;
				mask-image: unset;
				-webkit-mask-repeat: unset;
				mask-repeat: unset;
				mask-size: unset;
				mask-position: unset;
			}

			&.no-image {
				grid-column: 8 / span 5;
				mask-position: left center;
				-webkit-mask-image: var(--no-image-mask);
				mask-image: var(--no-image-mask);
				grid-column: 9 / span 4;

				@media (max-width: $tablet) {
					-webkit-mask-image: var(--image-mask-mobile);
					mask-image: var(--image-mask-mobile);
				}
			}

			@media (max-width: 1360px) {
				max-height: 100%;
				aspect-ratio: 735 / 500;
				height: 100%;
			}

			@media (max-width: $tablet) {
				-webkit-mask-image: var(--image-mask-mobile);
				mask-image: var(--image-mask-mobile);
				border-left: unset;
				grid-column: span 4;
				min-height: unset;
				max-height: 100%;
				aspect-ratio: 384 / 318;
				order: 0;

				.single-benefit_coverage & {
					display: none;
				}
			}

			> img:not(.device) {
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: var(--content-bg-pos);
			}
		}
	}
}
</style>
